<ul class="p-top-seatmap-flight__menu js-seatmap-flight-menu">
  <ng-container *ngFor="let flight of allSegmentInfo; index as i">
    <li
      [ngClass]="
        flight.id && this.isEligible(flight.id)
          ? 'p-top-seatmap-flight__menu-item js-seatmap-flight-menu-item'
          : 'p-top-seatmap-flight__menu-item js-seatmap-flight-menu-item list-disabled-item'
      "
    >
      <div class="p-top-seatmap-flight__menu-item-wrap">
        <button
          id="seatmapFlightBtn-{{ flight.id }}"
          class="p-top-seatmap-flight__btn js-seatmap-flight-menu-btn is-current"
          (click)="onClickSegment(flight.id)"
        >
          <span class="p-top-seatmap-flight__btn-wrap">
            <span class="p-top-seatmap-flight__btn-label">
              <span class="p-top-seatmap-flight__btn-date">
                {{ flight.departure?.dateTime || '' | dateFormat : 'default_departuredate' : true }}
              </span>
              <span class="p-top-seatmap-flight__airport">
                <span class="p-top-seatmap-flight__airport-departure">
                  {{ (flight.departure?.locationCode | airportNameI18n) || flight.departure?.locationName }}
                  <span class="p-top-seatmap-flight__airport-to">
                    <span
                      class="u-visually-hidden"
                      innerHTML="{{ 'm_static_message-alt.toOfArrivalAndDeparture' | staticMsg }}"
                    ></span>
                    <span aria-hidden="true">{{ 'label.hyphen' | staticMsg }}</span>
                  </span>
                </span>
                <span class="p-top-seatmap-flight__airport-arrival">
                  {{ (flight.arrival?.locationCode | airportNameI18n) || flight.arrival?.locationName }}
                </span>
              </span>
            </span>
          </span>
          <span class="p-top-seatmap-flight__btn-cur" *ngIf="this.displayTargetSegmentId === flight.id">
            <span class="checked-segment"></span>
          </span>
        </button>
      </div>
    </li>
  </ng-container>
</ul>
